import React, { useMemo, useState }from "react";
import { Icon } from 'dlweb-components';
import { Select, Spin } from "antd";
import styled from "styled-components";
import _ from 'lodash';

const UserPicker = ({blacklist, onSelect}) => {

  const [loading, setLoading] = useState(false);
  const [users, setUsers] = useState([]);
  const [filterValue, setFilterValue] = useState('ID');
  const fetchRef = React.useRef(0);

  const debounceFetcher = useMemo(() => {
    const loadUsers = (value) => {

      if(value.length < 2) return;

      fetchRef.current += 1;
      const fetchId = fetchRef.current;
      setUsers([]);
			setLoading(true);

      const searchFilter = {
        userSqlFilter:  { [filterValue]: value }
      }

			axios.post('/api/users/search/dto/grid', { limit: 500, skip: 0, ...searchFilter}).then(
				res => {
					if (fetchId !== fetchRef.current) return;

					const userList = _.filter(res.data.data, o => !_.includes(blacklist, o.id)).map((user) => ({
						label: <div>
                      <Icon
                        type='user'
                        size="lg"
                        faStyle='fas'
                        style={{
                            marginRight: '10px',
                            color: 'var(--primary-light)'
                        }}/>
                        <span style={{fontWeight: 600}}>
                          {user.firstName} {user.lastName}
                        </span> (<i>{user.id}</i>)
                    </div>,
						value: user.id,
					}))

					setUsers(userList);
          setLoading(false);
				})
    };

    return _.debounce(loadUsers, 500);
  }, [filterValue, blacklist]);

  return (
    <Container>
      <NoFlex>
        <Select
          style={{ width: '115px' }}
          value={filterValue}
          onSelect={(newValue) => {
            setFilterValue(newValue);
          }}
        >
          <Select.Option value="ID">Username</Select.Option>
          <Select.Option value="FirstName">First Name</Select.Option>
          <Select.Option value="LastName">Last Name</Select.Option>
        </Select>
      </NoFlex>
      <NoFlex style={{fontSize: '18px', padding: '0 5px'}}>=</NoFlex>
      <Flex>
        <Select
            labelInValue
            showSearch
            loading={loading}
            filterOption={false}
            options={users}
            placeholder="Search for user"
            onSearch={debounceFetcher}
            onSelect={(newValue) => {
              onSelect(newValue.value);
            }}
            style={{width: '100%'}}
            notFoundContent={loading ? <Spin size="small" /> : null}
        />
      </Flex>
    </Container>
  );
};

const Container = styled.div`
  padding: 20px 0;
  display: flex;
  flex-direction: row;
`

const NoFlex = styled.div`
  flex: none;
`

const Flex = styled.div`
  flex: 1;
`

export default UserPicker;
